export const identityFunction = <T>(val: T): T => val;

// todo: move emptyFn here as well
